import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DrrHttpClient } from '../../http/drr-http-client';
import { INCLUDE_AUTH_HEADERS } from '../../shared/services/http-context.tokens';
import { VendorConfigurationMode } from './mode-configuration.types';

@Injectable({
  providedIn: 'root',
})
export class ModeConfigurationService {

  constructor(private httpClient: DrrHttpClient) { }

  loadModeConfiguration$(appid: string): Observable<VendorConfigurationMode> {
    return this.httpClient.get<VendorConfigurationMode>(
      `bff/rap/config/${appid.toLowerCase()}`,
      {
        context: new HttpContext().set(INCLUDE_AUTH_HEADERS, false),
      }
    )
  }
}
